<app-header
    [isExpanded]="isExpanded"
    [showResponsive]="showResponsive"
    (responsiveFlag)="responsiveFlag($event)"
    (expandedFlag)="expandedFlag($event)"
></app-header>
<div class="two-panel">
    <div class="sidebar-menu-panel" [ngClass]="isExpanded ? 'left-panel' : 'side-menu-panel'">
        <mat-sidenav-container class="sidebar-menu-box">
            <mat-sidenav
                #sidenav
                class="sidebar-menu-con"
                mode="side"
                opened="true"
                (mouseenter)="mouseenter()"
                (mouseleave)="mouseleave()"
            >
                <mat-accordion>
                    <mat-nav-list>
                        @for (menu of menuList; track menu; let i = $index) {
                            <ng-container
                                [ngTemplateOutlet]="menu.children ? childMenu : parentMenu"
                                [ngTemplateOutletContext]="{ menu: menu }"
                            >
                            </ng-container>
                        }

                        <ng-template #parentMenu let-menu="menu">
                            <mat-list-item [ngClass]="menu.active ? 'active' : ''" (click)="openMenu(menu)">
                                <mat-icon [svgIcon]="menu.icon | svgToMatIcon"></mat-icon>
                                <span class="menu-txt">{{ isExpanded || showResponsive ? menu.text : '' }}</span>
                            </mat-list-item>
                        </ng-template>

                        <ng-template #childMenu let-menu="menu">
                            <mat-expansion-panel [class.mat-elevation-z0]="true">
                                <mat-expansion-panel-header [ngClass]="menu.active ? 'active' : ''">
                                    <mat-icon [svgIcon]="menu.icon | svgToMatIcon" [ngClass]="menu.active ? 'active' : ''"></mat-icon>
                                    <span class="menu-txt">{{ isExpanded || showResponsive ? menu.text : '' }}</span>
                                </mat-expansion-panel-header>
                                <mat-nav-list>
                                    @for (submenu of menu.children; track submenu.id) {
                                        <mat-list-item (click)="openMenu(menu, submenu)" [ngClass]="submenu.active ? 'active' : ''">
                                            <mat-icon
                                                [svgIcon]="submenu.icon | svgToMatIcon"
                                                [ngClass]="submenu.active ? 'active' : ''"
                                            ></mat-icon>
                                            <span class="menu-txt">{{ isExpanded || showResponsive ? submenu.text : '' }}</span>
                                        </mat-list-item>
                                    }
                                </mat-nav-list>
                            </mat-expansion-panel>
                        </ng-template>
                    </mat-nav-list>
                </mat-accordion>
            </mat-sidenav>
        </mat-sidenav-container>
    </div>

    <div class="main-content-box" [ngClass]="isExpanded ? 'right-panel' : 'side-content-panel'">
        <router-outlet></router-outlet>
    </div>
</div>
